import { c as _c } from "react/compiler-runtime";
import { Tabbar } from '@systemeio/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface AffiliateSectionTabListProps {
  ariaLabel: string;
}
export const AffiliateSectionTabList = t0 => {
  const $ = _c(22);
  const {
    ariaLabel
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-border-100 h-px min-w-0 flex-1" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Tabbar.Indicator variant="segmented" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("dashboard.affiliate.payments");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <Tabbar.Tab variant="segmented" value="payments">{t3}</Tabbar.Tab>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("dashboard.affiliate.leads.title");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <Tabbar.Tab variant="segmented" value="leads">{t5}</Tabbar.Tab>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t("dashboard.affiliate.invoices");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <Tabbar.Tab variant="segmented" value="invoices">{t7}</Tabbar.Tab>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== ariaLabel || $[15] !== t4 || $[16] !== t6 || $[17] !== t8) {
    t9 = <Tabbar.List variant="segmented" aria-label={ariaLabel}>{t2}{t4}{t6}{t8}</Tabbar.List>;
    $[14] = ariaLabel;
    $[15] = t4;
    $[16] = t6;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="bg-border-100 h-px min-w-0 flex-1" />;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t9) {
    t11 = <div className="mb-4 flex items-center gap-6 py-2">{t1}{t9}{t10}</div>;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};